import { render, staticRenderFns } from "./AdminRoleName.vue?vue&type=template&id=71063e2e&scoped=true&"
import script from "./AdminRoleName.vue?vue&type=script&lang=js&"
export * from "./AdminRoleName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71063e2e",
  null
  
)

export default component.exports